import React from 'react'

const LineProgressBar = ({ value, title }) => {
    const calculatePercentage = (value) => (value / 5) * 100;
    return (
        <div>
            <p className="text-[12px] md:text-[20px] font-[500] mb-1 sm:mb-[20px]">{title}</p>

            <div className="flex items-center justify-between mt-[-3px] mb-[10px] sm:mb-[20px] w-full">
                {/* Background Bar (Fixed Width) */}
                <div className="w-[90%] bg-gray-300 h-[5px] sm:h-[10px] rounded-full relative">
                    {/* Foreground Progress Bar */}
                    <div
                        className="bg-[#6C33B5] h-[5px] sm:h-[10px] rounded-full absolute top-0 left-0"
                        style={{ width: `${calculatePercentage(value)}%` }}
                    />
                </div>
                <span className="text-[10px] sm:text-[18px] ml-2">{value}</span>
            </div>

        </div>
    )
}

export default LineProgressBar